export const excludedDomainsSelector = (store) => {
    const excludedDomains = store.csatInfo.blockDomains;
    return typeof excludedDomains === "string"
        ? JSON.parse(excludedDomains)?.blocked ?? []
        : excludedDomains;
}

export const preventCSATAfterFeedbackSelector = (state) => state.csatInfo.preventCSATAfterFeedback ?? false;
export const isCsatBlockedDomainsEnabledSelector = (state) => state.csatInfo.blockDomainsEnabled ?? false;
